// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"192ce9b0","977":"6f2d738b"}[chunkId] + ".chunk.js";
};